import { render, staticRenderFns } from "./International.vue?vue&type=template&id=bd966b82"
import script from "./International.vue?vue&type=script&lang=js"
export * from "./International.vue?vue&type=script&lang=js"
import style0 from "./International.vue?vue&type=style&index=0&id=bd966b82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports